import React from 'react';
import { View } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';

import ListItemLoader from '../../Components/ListItemLoader';
import { RectangleLoader } from '../../Components/Loader';
import themeStyle from '../../Theme/styles';

import { styles } from './ReservationCard';

const ReservationCardLoader = () => {
  const theme = useTheme();
  return (
    <View style={[styles.wrapper, { borderColor: theme['color-info-500'] }]}>
      <View style={themeStyle.flex1}>
        <View style={themeStyle.spacingBottomXSmall}>
          <RectangleLoader width="100%" height={27.5} />
        </View>
        <View
          style={[
            themeStyle.flexDirectionRowCenter,
            themeStyle.spacingBottomXSmall,
          ]}
        >
          <RectangleLoader width={35} height={17.5} />
          <Text category="c1"> • </Text>
          <RectangleLoader width={50} height={17.5} />
          <Text category="c1"> • </Text>
          <RectangleLoader width={25} height={17.5} />
        </View>
        <View style={{ width: '20%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomXSmall}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
        <View style={{ width: '15%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomXSmall}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
        <View style={{ width: '10%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomXSmall}
            leftSize={20}
            textSize={23}
            withLeftIcon
          />
        </View>
      </View>
      <View
        style={[
          themeStyle.alignItemsCenter,
          themeStyle.justifyContentCenter,
          themeStyle.spacingLeftMedium,
        ]}
      >
        <View style={themeStyle.spacingBottomMedium}>
          <RectangleLoader width={55} height={55} />
        </View>
        <RectangleLoader width={89} height={19.5} />
      </View>
    </View>
  );
};

export default ReservationCardLoader;
